var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "{134}",
    height: "{106}",
    viewBox: "0 0 134 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: "{104}",
    r: 1.66667,
    transform: "rotate(-90 1.66667 104)",
    fill: "#3056D3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3333,
    cy: "{104}",
    r: 1.66667,
    transform: "rotate(-90 16.3333 104)",
    fill: "#3056D3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "{31}",
    cy: "{104}",
    r: 1.66667,
    transform: "rotate(-90 31 104)",
    fill: "#3056D3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: "{104}",
    r: 1.66667,
    transform: "rotate(-90 45.6667 104)",
    fill: "#3056D3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3334,
    cy: "{104}",
    r: 1.66667,
    transform: "rotate(-90 60.3334 104)",
    fill: "#3056D3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: "{104}",
    r: 1.66667,
    transform: "rotate(-90 88.6667 104)",
    fill: "#3056D3"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: "{104}",
    r: 1.66667,
    transform: "rotate(-90 117.667 104)",
    fill: "#3056D3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: "{104}",
    r: 1.66667,
    transform: "rotate(-90 74.6667 104)",
    fill: "#3056D3"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "{103}",
    cy: "{104}",
    r: 1.66667,
    transform: "rotate(-90 103 104)",
    fill: "#3056D3"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "{132}",
    cy: "{104}",
    r: 1.66667,
    transform: "rotate(-90 132 104)",
    fill: "#3056D3"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 89.3333,
    r: 1.66667,
    transform: "rotate(-90 1.66667 89.3333)",
    fill: "#3056D3"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3333,
    cy: 89.3333,
    r: 1.66667,
    transform: "rotate(-90 16.3333 89.3333)",
    fill: "#3056D3"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "{31}",
    cy: 89.3333,
    r: 1.66667,
    transform: "rotate(-90 31 89.3333)",
    fill: "#3056D3"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 89.3333,
    r: 1.66667,
    transform: "rotate(-90 45.6667 89.3333)",
    fill: "#3056D3"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3333,
    cy: 89.3338,
    r: 1.66667,
    transform: "rotate(-90 60.3333 89.3338)",
    fill: "#3056D3"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 89.3338,
    r: 1.66667,
    transform: "rotate(-90 88.6667 89.3338)",
    fill: "#3056D3"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 89.3338,
    r: 1.66667,
    transform: "rotate(-90 117.667 89.3338)",
    fill: "#3056D3"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 89.3338,
    r: 1.66667,
    transform: "rotate(-90 74.6667 89.3338)",
    fill: "#3056D3"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "{103}",
    cy: 89.3338,
    r: 1.66667,
    transform: "rotate(-90 103 89.3338)",
    fill: "#3056D3"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "{132}",
    cy: 89.3338,
    r: 1.66667,
    transform: "rotate(-90 132 89.3338)",
    fill: "#3056D3"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 74.6673,
    r: 1.66667,
    transform: "rotate(-90 1.66667 74.6673)",
    fill: "#3056D3"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 31.0003,
    r: 1.66667,
    transform: "rotate(-90 1.66667 31.0003)",
    fill: "#3056D3"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3333,
    cy: 74.6668,
    r: 1.66667,
    transform: "rotate(-90 16.3333 74.6668)",
    fill: "#3056D3"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3333,
    cy: 31.0003,
    r: 1.66667,
    transform: "rotate(-90 16.3333 31.0003)",
    fill: "#3056D3"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "{31}",
    cy: 74.6668,
    r: 1.66667,
    transform: "rotate(-90 31 74.6668)",
    fill: "#3056D3"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "{31}",
    cy: 31.0003,
    r: 1.66667,
    transform: "rotate(-90 31 31.0003)",
    fill: "#3056D3"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 74.6668,
    r: 1.66667,
    transform: "rotate(-90 45.6667 74.6668)",
    fill: "#3056D3"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 31.0003,
    r: 1.66667,
    transform: "rotate(-90 45.6667 31.0003)",
    fill: "#3056D3"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3333,
    cy: 74.6668,
    r: 1.66667,
    transform: "rotate(-90 60.3333 74.6668)",
    fill: "#3056D3"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3333,
    cy: 30.9998,
    r: 1.66667,
    transform: "rotate(-90 60.3333 30.9998)",
    fill: "#3056D3"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 74.6668,
    r: 1.66667,
    transform: "rotate(-90 88.6667 74.6668)",
    fill: "#3056D3"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 30.9998,
    r: 1.66667,
    transform: "rotate(-90 88.6667 30.9998)",
    fill: "#3056D3"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 74.6668,
    r: 1.66667,
    transform: "rotate(-90 117.667 74.6668)",
    fill: "#3056D3"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 30.9998,
    r: 1.66667,
    transform: "rotate(-90 117.667 30.9998)",
    fill: "#3056D3"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 74.6668,
    r: 1.66667,
    transform: "rotate(-90 74.6667 74.6668)",
    fill: "#3056D3"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 30.9998,
    r: 1.66667,
    transform: "rotate(-90 74.6667 30.9998)",
    fill: "#3056D3"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "{103}",
    cy: 74.6668,
    r: 1.66667,
    transform: "rotate(-90 103 74.6668)",
    fill: "#3056D3"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "{103}",
    cy: 30.9998,
    r: 1.66667,
    transform: "rotate(-90 103 30.9998)",
    fill: "#3056D3"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "{132}",
    cy: 74.6668,
    r: 1.66667,
    transform: "rotate(-90 132 74.6668)",
    fill: "#3056D3"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "{132}",
    cy: 30.9998,
    r: 1.66667,
    transform: "rotate(-90 132 30.9998)",
    fill: "#3056D3"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 60.0003,
    r: 1.66667,
    transform: "rotate(-90 1.66667 60.0003)",
    fill: "#3056D3"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 16.3333,
    r: 1.66667,
    transform: "rotate(-90 1.66667 16.3333)",
    fill: "#3056D3"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3333,
    cy: 60.0003,
    r: 1.66667,
    transform: "rotate(-90 16.3333 60.0003)",
    fill: "#3056D3"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3333,
    cy: 16.3333,
    r: 1.66667,
    transform: "rotate(-90 16.3333 16.3333)",
    fill: "#3056D3"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: "{31}",
    cy: 60.0003,
    r: 1.66667,
    transform: "rotate(-90 31 60.0003)",
    fill: "#3056D3"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: "{31}",
    cy: 16.3333,
    r: 1.66667,
    transform: "rotate(-90 31 16.3333)",
    fill: "#3056D3"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 60.0003,
    r: 1.66667,
    transform: "rotate(-90 45.6667 60.0003)",
    fill: "#3056D3"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 16.3333,
    r: 1.66667,
    transform: "rotate(-90 45.6667 16.3333)",
    fill: "#3056D3"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3333,
    cy: 60.0003,
    r: 1.66667,
    transform: "rotate(-90 60.3333 60.0003)",
    fill: "#3056D3"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3333,
    cy: 16.3333,
    r: 1.66667,
    transform: "rotate(-90 60.3333 16.3333)",
    fill: "#3056D3"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 60.0003,
    r: 1.66667,
    transform: "rotate(-90 88.6667 60.0003)",
    fill: "#3056D3"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 16.3333,
    r: 1.66667,
    transform: "rotate(-90 88.6667 16.3333)",
    fill: "#3056D3"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 60.0003,
    r: 1.66667,
    transform: "rotate(-90 117.667 60.0003)",
    fill: "#3056D3"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 16.3333,
    r: 1.66667,
    transform: "rotate(-90 117.667 16.3333)",
    fill: "#3056D3"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 60.0003,
    r: 1.66667,
    transform: "rotate(-90 74.6667 60.0003)",
    fill: "#3056D3"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 16.3333,
    r: 1.66667,
    transform: "rotate(-90 74.6667 16.3333)",
    fill: "#3056D3"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: "{103}",
    cy: 60.0003,
    r: 1.66667,
    transform: "rotate(-90 103 60.0003)",
    fill: "#3056D3"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: "{103}",
    cy: 16.3333,
    r: 1.66667,
    transform: "rotate(-90 103 16.3333)",
    fill: "#3056D3"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: "{132}",
    cy: 60.0003,
    r: 1.66667,
    transform: "rotate(-90 132 60.0003)",
    fill: "#3056D3"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: "{132}",
    cy: 16.3333,
    r: 1.66667,
    transform: "rotate(-90 132 16.3333)",
    fill: "#3056D3"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 45.3333,
    r: 1.66667,
    transform: "rotate(-90 1.66667 45.3333)",
    fill: "#3056D3"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 1.66683,
    r: 1.66667,
    transform: "rotate(-90 1.66667 1.66683)",
    fill: "#3056D3"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3333,
    cy: 45.3333,
    r: 1.66667,
    transform: "rotate(-90 16.3333 45.3333)",
    fill: "#3056D3"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3333,
    cy: 1.66683,
    r: 1.66667,
    transform: "rotate(-90 16.3333 1.66683)",
    fill: "#3056D3"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: "{31}",
    cy: 45.3333,
    r: 1.66667,
    transform: "rotate(-90 31 45.3333)",
    fill: "#3056D3"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: "{31}",
    cy: 1.66683,
    r: 1.66667,
    transform: "rotate(-90 31 1.66683)",
    fill: "#3056D3"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 45.3333,
    r: 1.66667,
    transform: "rotate(-90 45.6667 45.3333)",
    fill: "#3056D3"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 1.66683,
    r: 1.66667,
    transform: "rotate(-90 45.6667 1.66683)",
    fill: "#3056D3"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3333,
    cy: 45.3338,
    r: 1.66667,
    transform: "rotate(-90 60.3333 45.3338)",
    fill: "#3056D3"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3333,
    cy: 1.66683,
    r: 1.66667,
    transform: "rotate(-90 60.3333 1.66683)",
    fill: "#3056D3"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 45.3338,
    r: 1.66667,
    transform: "rotate(-90 88.6667 45.3338)",
    fill: "#3056D3"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 1.66683,
    r: 1.66667,
    transform: "rotate(-90 88.6667 1.66683)",
    fill: "#3056D3"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 45.3338,
    r: 1.66667,
    transform: "rotate(-90 117.667 45.3338)",
    fill: "#3056D3"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 1.66683,
    r: 1.66667,
    transform: "rotate(-90 117.667 1.66683)",
    fill: "#3056D3"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 45.3338,
    r: 1.66667,
    transform: "rotate(-90 74.6667 45.3338)",
    fill: "#3056D3"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 1.66683,
    r: 1.66667,
    transform: "rotate(-90 74.6667 1.66683)",
    fill: "#3056D3"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: "{103}",
    cy: 45.3338,
    r: 1.66667,
    transform: "rotate(-90 103 45.3338)",
    fill: "#3056D3"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: "{103}",
    cy: 1.66683,
    r: 1.66667,
    transform: "rotate(-90 103 1.66683)",
    fill: "#3056D3"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: "{132}",
    cy: 45.3338,
    r: 1.66667,
    transform: "rotate(-90 132 45.3338)",
    fill: "#3056D3"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: "{132}",
    cy: 1.66683,
    r: 1.66667,
    transform: "rotate(-90 132 1.66683)",
    fill: "#3056D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.80375f11aca6e035103f7a9559f01880.svg";
export { ForwardRef as ReactComponent };